export default {
  setLoader(state, isOpen) {
    state.isLoading = isOpen
  }
}
